import { createLogEntry } from "./logentry/createLogEntry";
import { setContext } from "./logentry/setContext";
import { setData } from "./logentry/setData";
import { formatEntry } from "./logentry/formatEntry";
import { Loglevel } from "~/modules/logger";

const factories = [createLogEntry, setContext, setData, formatEntry].reverse();

export const logEntryPlugin = (loglevel: Loglevel): Loglevel => {
    factories.forEach((f) => {
        const originalFactory = loglevel.methodFactory;

        loglevel.methodFactory = f(originalFactory);
    });

    loglevel.setLevel(loglevel.getLevel());
    return loglevel;
};
